import { render } from "./InventoryHistory.vue?vue&type=template&id=fd337d4c"
import script from "./InventoryHistory.vue?vue&type=script&lang=js"
export * from "./InventoryHistory.vue?vue&type=script&lang=js"
script.render = render

export default script